import {AfterViewInit, Component, OnInit} from '@angular/core';
import {language} from '../../../language/vn';
import {environment} from '../../../../environments/environment';
import {Sessioncommand} from '../../../global/sessioncommand';

import {BsModalService} from 'ngx-bootstrap/modal';
import {CalendarNewsService} from '../../../service/calendar/service-calendarnews';
import {CalendarNews} from '../../../models/calendar/calendarnews';
import {ReadThongBaoComponent} from './read.component';
import {ReadLichCongTacComponent} from '../lichcongtac/readlichcongtac.component';
@Component({
  selector: 'ui-egov-lich-hot-show',
  templateUrl: './thongbaolich.component.html'

})
export class ThongBaoLichComponent implements OnInit, AfterViewInit {
  public language = language;
  public dataLich: CalendarNews[] = [];
  public currentPage: number = 1;
  public maxSize: number = 10;
  public status: number[] =[   environment.chuaxuly  ];
  public xem: number = -1;
  constructor(  public calendarNewsService: CalendarNewsService,
                public bsModalService: BsModalService

  ) {
  }
  ngAfterViewInit() {
    setInterval(() =>{ this.loadThongBao() }, 120 * 1000);
  }
  public loadThongBao()
  {
    this.calendarNewsService.findByWeek( Sessioncommand.maDonVi, -1,  0).subscribe(dataList => this.dataLich = dataList);
  }
  public thongBao(id: number) {

    const modalEdit = this.bsModalService.show(ReadLichCongTacComponent, {class: 'modal-xl', keyboard: false, backdrop: 'static'});
    (<ReadLichCongTacComponent>modalEdit.content).edit(
      id
    );
    (<ReadLichCongTacComponent>modalEdit.content).onClose.subscribe(result => {

    });

  }
  ngOnInit(): void {
  }

}

